/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { type ValidationErrors, type ValidatorFn } from '@angular/forms';
import { type FormControl, I18nService } from '@dm/core';

@Injectable({ providedIn: 'root' })
export class FileDnsServiceStrService {
    i18n = {
        tip: this.get('settings.fileStorageService_task_setDNS_explanation_lab'),
        ipTip: this.get('common.IPv4orIPv6_label'),

        dnsServiceTitle: this.i18nService.get('common.dnsService_title'),
        manageServiceDNS: this.get('service.vstore_dnsService_term_manageServiceDNS_title'),

        primaryDnsIpLab: this.get('settings.dnsService_term_mainDnsIP_label'),
        standbyDnsIp1Lab: this.get('settings.dnsService_task_setDns_para_slaveDNSIP_label') + ' 1',
        standbyDnsIp2Lab: this.get('settings.dnsService_task_setDns_para_slaveDNSIP_label') + ' 2',

        testBtn: this.get('common.test'),
        testAllBtn: this.get('common.test_all'),
        saveBtn: this.get('common.save_button'),
        confirmBtn: this.get('common.confirm_button'),
        cancelBtn: this.get('common.cancel_button'),
        configureBtn: this.i18nService.get('common.configure_button'),

        testSuccessResult: this.get('settings.dnsService_task_testDNSAddress_success_msg'),
        successResult: this.get('common.save_success_result'),

        ipErr: this.get('common.IPAddr_validation'),
        repeatErr: this.get('common.duplicateIp_label'),

        cancelMsg: this.get('common.cancleCurrentPage_label'),

        testRest: this.get('rest.testDNSIPAddress_msg'),

        DnsIPTitle: this.get('settings.dnsService_term_DnsIP_label'),
        domainTitle: this.get('settings.dnsService_task_DNSDomainName_label'),
        domainName: this.get('settings.dnsService_task_domainName_col'),
        domainNameMsg: this.get('settings.dnsService_task_domainName_msg'),
        domainNamevalid: this.get('settings.dnsService_task_domainName_valid'),
        addButton: this.get('common.add_button'),
        operation: this.get('common.operation_button'),
        unconfigureLab: this.get('common.unconfigured_lab'),
    };

    constructor(
        private i18nService: I18nService,
    ) { }

    get(key: string, params?: boolean | any[], colon?: boolean): string {
        return this.i18nService.get(key, params, colon);
    }

    testName(ip: string): string {
        return this.get('rest.testDNSIPAddress_msg', [ip]);
    }

    /**
     * DNS域名校验
     * 具体范围：
     * 1、域名不区分大小写，不能与已有域名重复
     * 2、域名总长度范围是3到255位，只能由字母、数字、“.”、“_”和“-”组成
     * 3、每个由“.”分割的各级域名长度不超过63个字符，只能由字母或数字开头或结尾
     */
    domainNameValidator(): ValidatorFn {
        return (control: FormControl): ValidationErrors | null => {
            const reg = /^(?=^.{1,255}$)(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9_-]{0,61}[a-zA-Z0-9])[.])*([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9_-]{0,61}[a-zA-Z0-9])$/;
            if (!reg.test(control.value)) {
                return { domainName : true };
            }
            return null;
        };
    }
}

/**
 * 支持最大DNS域名数
 */
export const MAXDNSNUMBER = 6;
export const controlKeyPrefix = 'domainName';
export const indexKey = 'number';

export interface ControlValer {
    [key: string]: string;
}
